import { QueryClient } from '@tanstack/react-query';

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 60_000,
      gcTime: 5 * 60_000,
      // No retries: 4xx is a real client error (no point retrying) and 5xx is
      // either a backend bug (also no point retrying) or a transient network
      // blip (the user can hit Refrescar). Retries during development just
      // create noise and make backend errors look intermittent.
      retry: false,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});
